var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPinterestWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 124 124",
    viewBox: "0 0 124 124",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M67.8,83.8c-5.5-0.4-7.8-3.1-12.1-5.7c-1.9,10-4.2,19.7-9.5,26.3c-1.6,1.9-4.7,1-4.8-1.5 c-0.8-16,4.7-28.7,7.4-42c-5.1-8.7,0.6-26.1,11.5-21.8c13.4,5.3-11.6,32.2,5.2,35.6C83,78.1,90.2,44.3,79.3,33.3 c-15.7-15.9-45.6-0.4-41.9,22.4c0.7,4.3,4.3,6.3,3.9,10.6c-0.3,2.7-3,4.2-5.4,3.1c-6.9-3.2-9.1-10.3-8.8-19.4 c0.6-17.2,15.5-29.3,30.4-31c18.9-2.1,36.6,6.9,39,24.7C99.3,63.6,88,85.3,67.8,83.8L67.8,83.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinterestWhite);
export default __webpack_public_path__ + "static/media/icon-pinterest-white.35edce3d6eb657273d12c4c00b40e09b.svg";
export { ForwardRef as ReactComponent };